import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import Button from 'modules/_shared/components/Buttons';
import { useRenumerationModal } from '../context/RenumerationModalContext';
import { renumerationModes } from '../constants/renumerationModes';

const RenumerationModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useRenumerationModal();

  const hasValidDate = data.date && data.date >= data.lastOperationDate;

  const hasHistoryMovements =
    data.historyMovements && data.historyMovements.length > 0;

  const hasReassignedRanges = data.reassignedRanges.length > 0;

  const isAutomatic = data.renumerationMode === renumerationModes.AUTOMATIC;

  const isEntireClassReady =
    data.isEntireClassRenumeration && Boolean(data.selectedHoldingClassOption);

  const buttonEnabledScriptureView = data.scriptureView && hasValidDate;

  const buttonEnabledMovementsView = !data.scriptureView && hasHistoryMovements;

  const buttonEnabledSaveMovement =
    hasReassignedRanges ||
    ((isAutomatic || isEntireClassReady) && !hasHistoryMovements);

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <Modal.Footer>
      <div className="d-flex justify-content-between w-100 align-items-center">
        {!data.scriptureView && (
          <Button
            text={t('SaveMovement')}
            onClick={actions.handleSaveMovement}
            disabled={!buttonEnabledSaveMovement}
            lgSize
          />
        )}
        <Button
          text={buttonText}
          onClick={actions.handleSaveRenumeration}
          disabled={!buttonEnabledScriptureView && !buttonEnabledMovementsView}
          lgSize
        />
      </div>
    </Modal.Footer>
  );
};

export default RenumerationModalFooter;
